/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// eslint-disable-next-line no-undef
const imagesPrefix = `${process.env.PUBLIC_URL}/assets/images/offering`;

export default [
  {
    title: "Energy Management & Efficiency",
    description:
      "We help organizations understand, manage and optimize their energy use through data-driven assessments, energy management strategies and efficiency solutions. Our approach focuses on reducing energy costs, improving performance, supporting regulatory compliance and sustaining energy savings over time.",
    items: [
      {
        image: `${imagesPrefix}/energy-audits.jpeg`,
        name: "Energy Audits ",
        pro: false,
      },
      {
        image: `${imagesPrefix}/energy_strategy.jpg`,
        name: "Energy Efficiency Consultancy",
        pro: false,
      },
      {
        image: `${imagesPrefix}/energy_policy.png`,
        name: "Energy Management Committee support",
        pro: false,
      },
      {
        image: `${imagesPrefix}/energy_management_system.jpg`,
        name: "Energy Management Systems",
        pro: false,
      },
      {
        image: `${imagesPrefix}/energy_benchmarking.png`,
        name: "Energy Benchmarking ",
        pro: false,
      },
      {
        image: `${imagesPrefix}/energy_regulatory_compliance.png`,
        name: "Regulatory Compliance ",
        pro: false,
      },
      {
        image: `${imagesPrefix}/energy_performance_reporting.png`,
        name: "Energy Performance Management",
        pro: false,
      },
    ],
  },
  {
    title: "MEP Engineering & Management",
    description:
      "We provide integrated Mechanical, Electrical and Plumbing (MEP) engineering and management solutions that balance performance, cost, efficiency and reliability. From design review and value engineering to procurement, project coordination and commissioning, we help clients deliver building systems that perform effectively throughout their lifecycle.",
    items: [
      {
        image: `${imagesPrefix}/mep-engineering.jpeg`,
        name: "MEP Engineering",
        pro: false,
      },
      {
        image: `${imagesPrefix}/design-review.jpeg`,
        name: "Design Review",
        pro: false,
      },
      {
        image: `${imagesPrefix}/value-engineering.jpeg`,
        name: "Value Engineering",
        pro: false,
      },
      {
        image: `${imagesPrefix}/boq-review.jpeg`,
        name: "BOQ Review",
        pro: false,
      },
      {
        image: `${imagesPrefix}/project-management.jpeg`,
        name: "Project Management",
        pro: false,
      },
      {
        image: `${imagesPrefix}/site-supervision.jpeg`,
        name: "Site Supervision",
        pro: false,
      },
      {
        image: `${imagesPrefix}/commissioning.jpeg`,
        name: "Commissioning",
        pro: false,
      },
      {
        image: `${imagesPrefix}/procurement.jpeg`,
        name: "Procurement & Technical Support",
        pro: false,
      },
    ],
  },
  {
    title: "Renewable Energy",
    description:
      "We help our clients transition to cleaner and more reliable energy through appropriately designed renewable energy solutions. From feasibility and system design to implementation and performance monitoring, we develop solutions that reduce energy costs, improve energy resilience and support the transition to a low-carbon future.",
    items: [
      {
        image: `${imagesPrefix}/solar-pv.jpeg`,
        name: "Solar PV",
        pro: false,
      },
      {
        image: `${imagesPrefix}/solar-hybrid.jpeg`,
        name: "Solar Hybrid Systems",
        pro: false,
      },
      {
        image: `${imagesPrefix}/solar-thermal.jpeg`,
        name: "Solar Thermal",
        pro: false,
      },
      {
        image: `${imagesPrefix}/heat-pump.jpeg`,
        name: "Heat Pumps",
        pro: false,
      },
      {
        image: `${imagesPrefix}/feasibility-studies.jpeg`,
        name: "Renewable Energy Feasibility Studies",
        pro: false,
      },
      {
        image: `${imagesPrefix}/renewable-energy.jpeg`,
        name: "Renewable Energy Integration",
        pro: false,
      },
    ],
  },
  {
    title: "Smart Energy & Water Monitoring",
    description:
      "We provide smart monitoring solutions that give organizations real-time visibility into their energy and water consumption. By turning operational data into actionable insights, we help clients identify inefficiencies, optimize performance, control costs and measure the impact of efficiency interventions.",
    items: [
      {
        image: `${imagesPrefix}/smart-metering.jpeg`,
        name: "Smart Metering",
        pro: false,
      },
      {
        image: `${imagesPrefix}/metering.jpeg`,
        name: "Real-Time Energy Monitoring",
        pro: false,
      },
      {
        image: `${imagesPrefix}/implementation_support.png`,
        name: "Energy Analytics",
        pro: false,
      },
      {
        image: `${imagesPrefix}/performance-dashboards.jpeg`,
        name: "Performance Dashboards",
        pro: false,
      },
      {
        image: `${imagesPrefix}/data_analytics.png`,
        name: "Water Monitoring",
        pro: false,
      },
      {
        image: `${imagesPrefix}/implementation_support.png`,
        name: "Measurement & Verification",
        pro: false,
      },
    ],
  },
  {
    title: "Sustainability & Capacity Building",
    description:
      "We help organizations translate sustainability goals into practical, measurable action. Our advisory services support clients in strengthening resource efficiency, reducing environmental impact, managing carbon and embedding sustainability into their strategies, operations and decision-making.",
    items: [
      {
        image: `${imagesPrefix}/smart_metering.png`,
        name: "ESG & Sustainability Advisory",
        pro: false,
      },
      {
        image: `${imagesPrefix}/data_visualization.png`,
        name: "Carbon & Energy Management",
        pro: false,
      },
      {
        image: `${imagesPrefix}/sustainability-strategy.jpeg`,
        name: "Sustainability Strategy",
        pro: false,
      },
      {
        image: `${imagesPrefix}/energy-awareness.jpeg`,
        name: "Staff Energy Awareness",
        pro: false,
      },
      {
        image: `${imagesPrefix}/energy-management-training.jpeg`,
        name: "Energy Management Training for all staff levels",
        pro: false,
      },
    ],
  },
];
